/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used for the Configuration capability.
 * @export
 */
export const CONFIGURATION_CAPABILITY_STRINGS = {
  altTitle: `configuration`,
  dialogBlurb: `lets you tailor settings related to the underlying platform and overall functionality of the DXP.`,
  dialogBullet1: `Streamline your workflow by automating content and data management tasks.`,
  dialogBullet2: `Manage DXP service settings enabling a more cohesive and efficient environment for your organization.`,
  dialogBullet3: `Manage API keys for trusted information exchange between external sources and DXP services.`,
  subtitle: `Manage technical settings, AI content tools, auth/SSO and automation.`,
  title: `Configuration`,
};
